<!-- Titolo, contenuto e fascia delle azioni sono figli DIRETTI della superficie
     (niente <div> di raggruppamento): e' la condizione perche' la veste
     .izy-info-dialog-panel tenga la fascia panna a filo del bordo inferiore. -->
<h2 mat-dialog-title>Attenzione: conferma dati</h2>

<mat-dialog-content>
  <p class="izy-warning-message">
    Il cliente selezionato per questa fattura ha alcuni campi non valorizzati:
  </p>

  <!-- I due campi nel riquadro d'attenzione: superficie bianca bordata nera
       2px con la fascia lilla sul bordo sinistro, la tinta --warn della
       palette. Stessa grammatica dell'esito dell'import XML - lime quando e'
       andata bene, rossa quando e' un errore - e qui lilla, perche' non e' ne'
       l'uno ne' l'altro: si puo' proseguire lo stesso. -->
  <div class="izy-warning-box izy-sharp-bl">
    <mat-icon class="izy-warning-icon">warning</mat-icon>

    <dl class="izy-warning-fields">
      <dt>Partita IVA</dt>
      <!-- Il valore mancante e' proprio il motivo per cui questo dialog si
           apre: senza segnaposto la riga resterebbe vuota, e non si capirebbe
           quale dei due campi manca. -->
      <dd [class.izy-field-missing]="!iva_number">
        {{ iva_number || 'non presente' }}
      </dd>

      <dt>Codice Fiscale</dt>
      <dd [class.izy-field-missing]="!c_f">{{ c_f || 'non presente' }}</dd>
    </dl>
  </div>

  <p class="izy-warning-note">
    Ricorda che <strong>almeno uno</strong> dei due campi deve essere presente.
    Puoi proseguire lo stesso, ma dati mancanti (come la Partita IVA assente)
    potrebbero causare errori durante l'invio.
  </p>

  <!-- La spunta obbligatoria in un riquadro a se', come nel dialog di conferma
       condiviso: e' il cancello del "Prosegui", non una riga di testo in mezzo
       al messaggio. -->
  <div class="izy-confirm-box izy-sharp-bl">
    <mat-checkbox [(ngModel)]="confirmed" color="primary">
      <span class="fw-bold">Sì, i dati del cliente sono corretti</span>
    </mat-checkbox>
  </div>
</mat-dialog-content>

<mat-dialog-actions align="end" class="izy-dialog-actions">
  <button
    mat-stroked-button
    type="button"
    mat-dialog-close
    class="izy-button-ghost custom-button-border">
    <mat-icon>arrow_back</mat-icon>
    Torna indietro
  </button>

  <button
    matButton="filled"
    type="button"
    [disabled]="!confirmed"
    (click)="confirm()"
    class="ms-2 izy-button-primary custom-button-border">
    <mat-icon>check</mat-icon>
    Prosegui
  </button>
</mat-dialog-actions>
